<template>
  <section>
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      :selectBut="false"
    ></toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      size="small"
      :height="getTableHeight(165)"
      fit
    >
      <el-table-column prop="Sort" label="排序" width="50"></el-table-column>
      <el-table-column prop="Name" label="名称" width="200"></el-table-column>
      <el-table-column prop="ImgPath" label="图片">
        <template slot-scope="scope">
          <div
            class="bannerimg"
            :style="{
              backgroundImage: 'url(' + tabImgPathUrl + scope.row.ImgPath + ')',
            }"
          ></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="ModelName"
        label="模式"
        width="100"
      ></el-table-column>
      <el-table-column label="开放时间" width="160">
        <template slot-scope="scope">
          <span>{{ formatDate(scope.row.StartTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Enabled" label="状态" width="60">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Enabled ? "正常" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
    </el-table>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="FormRules"
        ref="editForm"
      >
        <el-form-item label="名称" prop="Name">
          <el-input v-model="editForm.Name"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="Sort">
          <el-input
            v-model.number="editForm.Sort"
            type="text"
            maxlength="2"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="EditImgPath">
          <div class="upload-img-form">
            <el-upload
              class="upload-img"
              :auto-upload="false"
              action="xxx"
              list-type="picture"
              :show-file-list="false"
              :on-change="uphandleChange"
              :style="{
                backgroundImage:
                  'url(' + baseImgPathUrl + editForm.EditImgPath + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'contain',
              }"
              accept="image/png, image/gif, image/jpg, image/jpeg"
            >
              <i
                v-show="!editForm.EditImgPath"
                class="el-icon-upload avatar-uploader-icon"
              ></i>
              <i
                v-show="editForm.EditImgPath"
                class="el-icon-refresh avatar-uploader-icon"
              ></i>
              <div
                v-show="!editForm.EditImgPath"
                slot="tip"
                class="el-upload__text upload__tip"
              >
                上传照片
              </div>
              <div
                v-show="editForm.EditImgPath"
                slot="tip"
                class="el-upload__text upload__tip"
              >
                重新选择
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="背景色" prop="BgColor">
          <el-color-picker v-model="editForm.BgColor"></el-color-picker>
        </el-form-item>
        <el-form-item label="开放时间" prop="StartTime">
          <el-date-picker
            v-model="editForm.StartTime"
            type="datetime"
            placeholder="选择时间"
            format="yyyy-MM-dd HH:mm"
            :editable="false"
            @change="updateChangebirthday"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="模式">
          <el-select
            v-model.number="editForm.Model"
            placeholder="请选模式"
            prop="Model"
          >
            <el-option
              v-for="item in modelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Url" prop="Url" v-if="editForm.Model != 1">
          <el-input v-model="editForm.Url"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="editForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="FormRules"
        ref="addForm"
      >
        <el-form-item label="名称" prop="Name">
          <el-input v-model="addForm.Name"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="Sort">
          <el-input
            v-model.number="addForm.Sort"
            type="text"
            maxlength="2"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="ImgPath">
          <div class="upload-img-form">
            <el-upload
              class="upload-img"
              :auto-upload="false"
              action="xxx"
              list-type="picture"
              :show-file-list="false"
              :on-change="handleChange"
              :style="{
                backgroundImage: 'url(' + addForm.ImgPath + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'contain',
              }"
              accept="image/png, image/gif, image/jpg, image/jpeg"
            >
              <i
                v-show="!addForm.ImgPath"
                class="el-icon-upload avatar-uploader-icon"
              ></i>
              <i
                v-show="addForm.ImgPath"
                class="el-icon-refresh avatar-uploader-icon"
              ></i>
              <div
                v-show="!addForm.ImgPath"
                slot="tip"
                class="el-upload__text upload__tip"
              >
                上传照片
              </div>
              <div
                v-show="addForm.ImgPath"
                slot="tip"
                class="el-upload__text upload__tip"
              >
                重新选择
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="背景色" prop="BgColor">
          <el-color-picker v-model="addForm.BgColor"></el-color-picker>
        </el-form-item>
        <el-form-item label="开放时间" prop="StartTime">
          <el-date-picker
            v-model="addForm.StartTime"
            type="datetime"
            placeholder="选择时间"
            format="yyyy-MM-dd hh:mm"
            :editable="false"
            @change="updateChangebirthday"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="模式">
          <el-select
            v-model.number="addForm.Model"
            placeholder="请选模式"
            prop="Model"
          >
            <el-option
              v-for="item in modelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Url" prop="Url" v-if="addForm.Model != 1">
          <el-input v-model="addForm.Url"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="addForm.Enabled"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "util/date";
import {
  base,
  getShopBannerListPage,
  removeShopBanner,
  editShopBanner,
  addShopBanner,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
import Toolbar from "@/components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      modelList: [
        { label: "纯图片", value: 1 },
        { label: "小程序URL", value: 2 },
        { label: "网页URL", value: 3 },
      ],
      list: [],
      listLoading: false,
      currentRow: null,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      FormRules: {
        Sort: [{ type: "integer", required: true, message: "请输入排序" }],
        Name: [{ required: true, message: "请输入名称" }],
        StartTime: [{ required: true, message: "请输入开放时间" }],
        Model: [{ required: true, message: "请输选择模式" }],
        ImgPath: [{ required: true, message: "请选择图片" }],
        EditImgPath: [{ required: true, message: "请选择图片" }],
      },
      //编辑界面数据
      editForm: {},

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {},
      baseImgPathUrl: "",
      tabImgPathUrl: "",
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    dateChangebirthday(val) {
      this.addForm.StartTime = this.formatDate(val);
    },
    updateChangebirthday(val) {
      this.editForm.StartTime = this.formatDate(val);
    },
    // 图片预览
    handleChange(file) {
      this.addForm.ImgPath = file.url;
      this.getBase64(file.raw).then((res) => {
        this.addForm.ImgPathFile = res;
      });
      this.$refs["addForm"].validateField("ImgPath");
    },
    // 图片预览
    uphandleChange(file) {
      this.baseImgPathUrl = "";
      this.editForm.EditImgPath = file.url;
      this.getBase64(file.raw).then((res) => {
        this.editForm.ImgPathFile = res;
      });
      this.$refs["editForm"].validateField("EditImgPath");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    //获取列表
    getList() {
      let _this = this;
      let para = {};
      this.listLoading = true;
      getShopBannerListPage(para).then((res) => {
        this.list = res.data.response;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeShopBanner(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.editForm.EditImgPath = this.editForm.ImgPath;
      this.editForm.ImgPathFile = "";
      this.baseImgPathUrl = base + "/FileUpload/BannerImg/a0/";
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Sort: 10,
        Name: "",
        BgColor: "",
        ImgPath: "",
        ImgPathFile: null,
        StartTime: util.formatDate.format(new Date(), "yyyy-MM-dd hh:mm"),
        Model: 1,
        Url: "",
        Enabled: true,
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);

            editShopBanner(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.$refs.listTable.setCurrentRow();
                this.getList();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);

            addShopBanner(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getList();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    this.getList();
    this.tabImgPathUrl = base + "/FileUpload/BannerImg/a0/";
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style scoped>
.upload-img-form {
  width: 400px;
}
.bannerimg {
  width: 400px;
  height: 150px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
}
</style>